import type { FC } from "react";

import { AppStrings } from "../../../utils/constants/AppStrings";

import type { AffiliateStatus } from "../affiliatesData";

import styles from "./AffiliateStatusBadge.module.css";

export type AffiliateStatusBadgeProps = {
  status: AffiliateStatus;
};

const AffiliateStatusBadge: FC<AffiliateStatusBadgeProps> = ({ status }) => (
  <span
    className={`${styles.statusBadge} ${
      status === "active" ? styles.statusActive : styles.statusDeactivated
    }`}
  >
    {status === "active"
      ? AppStrings.ACTIVE
      : AppStrings.DEACTIVATED_LABEL}
  </span>
);

export default AffiliateStatusBadge;
